__turbopack_context__.v({
  "breadcrumb-container": "breadcrumb-navigation-module-scss-module__Ic0-Pa__breadcrumb-container",
  "hide-first-on-mobile": "breadcrumb-navigation-module-scss-module__Ic0-Pa__hide-first-on-mobile",
});
